import { render, staticRenderFns } from "./PBRInterfaceForm.vue?vue&type=template&id=db4ac85c&"
import script from "./PBRInterfaceForm.vue?vue&type=script&lang=js&"
export * from "./PBRInterfaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports